export const blurQueryResult = {
  mounted() {
    // We locate inputs using name attribute, irrespective of the form's name
    const companyIdInput = this.find('input[name$="[company_name]"]')
    const paramsInput = this.find('input[name$="[input]"]')
    const queryResultTable = this.find('[data-role="query-result"]')
    const contactFindForm = this.find('form[id$="contact-find"]')

    let focusedInput = null

    function addBlurClass() {
      queryResultTable.classList.add("blur-sm")
    }

    function removeBlurClass() {
      queryResultTable.classList.remove("blur-sm")
      if (focusedInput) {
        focusedInput.blur()
      }
    }

    companyIdInput.addEventListener("focus", function () {
      addBlurClass()
      focusedInput = companyIdInput
    })
    paramsInput.addEventListener("focus", function () {
      addBlurClass()
      focusedInput = paramsInput
    })

    companyIdInput.addEventListener("blur", function () {
      focusedInput = null
      removeBlurClass()
    })
    paramsInput.addEventListener("blur", function () {
      focusedInput = null
      removeBlurClass()
    })

    contactFindForm.addEventListener("submit", function (event) {
      removeBlurClass()
    })
  },

  find(selector) {
    const input = this.el.querySelector(selector)
    if (!input) throw new Error(`${selector} not found (blurQueryResult)`)
    return input
  },
}
